import type { FC } from "react"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import fp from "lodash/fp"

import { useUpdateDeviceGroupNameMutation } from "../../../features/api"
import { selectCurrentOrgId } from "../../../features/store/orgSlice"
import EditableTitle from "../../common/editable/EditableTitle"
import ErrorPopUp from "../../common/ErrorPopUp"

interface IEditableDeviceGroupNameProps {
  name: string
}

const EditableDeviceGroupName: FC<IEditableDeviceGroupNameProps> = ({ name }) => {
  const { id } = useParams()
  const orgId = useSelector(selectCurrentOrgId)
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)
  const [updateDeviceGroupName, { isLoading, isSuccess, isError, error }] =
    useUpdateDeviceGroupNameMutation()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const onSubmitHandler = (newGroupName: string) => {
    updateDeviceGroupName({
      group_id: Number(id),
      new_group_name: newGroupName,
      org_id: orgId as number,
    })
  }

  useEffect(() => {
    if (isError) {
      handleOpen()
      setErrorMessage(fp.get("data.message", error) || null)
    }
  }, [isError, error])

  return (
    <>
      <EditableTitle
        text={name}
        onSubmitHandler={onSubmitHandler}
        isLoading={isLoading}
        isSuccess={isSuccess}
      />

      <ErrorPopUp open={open} onClose={handleClose}>
        {errorMessage ? errorMessage : t("error.UPDATING_GROUP_NAME")}
      </ErrorPopUp>
    </>
  )
}

export default EditableDeviceGroupName
